import { combineReducers } from 'redux';

import * as types from '../actions/ActionTypes';

export const initialState = {
  contacts: [],
  isFetching: false,
};

/**
 * Array of non obfuscated contacts
 * @param state
 * @param action
 * @return {*}
 */
export const contacts = (state = initialState.contacts, action) => {
  switch (action.type) {
    case types.GET_CONTACT_DATA_SUCCESS:
      if (action.payload.step === 'confirm') {
        return [
          ...state,
          action.payload.contact,
        ];
      }
      return state;
    default:
      return state;
  }
};

/**
 * Boolean is fetching contact data
 * @param state
 * @param action
 * @return {boolean}
 */
export const isFetching = (state = initialState.isFetching, action) => {
  switch (action.type) {
    case 'REQUEST_ALL_CONTACT_DATA':
      return true;
    case 'RECEIVE_ALL_CONTACT_DATA_SUCCESS':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  contacts,
  isFetching,
});
